"use client"

import { Component } from "react"
import { Typography, Paper, Grid, TextField, MenuItem, Box, Button } from "@mui/material"
import Header from "../../components/Header"
import API, { URL_PATH } from "../../services/API"
import Table from "../../components/Table"
import moment from "moment"
import Toast from "../../components/Toast"
import assets from "../../common/assets"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import RestaurantIcon from "@mui/icons-material/Restaurant"
import DeleteIcon from "@mui/icons-material/Delete"
import ConfirmationModal from "../../components/ConfirmationModal"
import redux from "../../common/Redux" // Import the redux HOC
import { CustomDatePicker } from "../../components/CustomDatePicker"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import routes from "../../routes/URL";


const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21",
  textColor: "#FFFFFF",
}

class Orders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      selectedRows: [],
      isBulkDeleteConfirmationModalOpen: false,
      fromDate: "",
      toDate: "",
      filter: "all",
      payment_method: "all_pay", // Add this line
      page: 1,
      lastPage: 1,
      total: 0,
      perPage: 0,
      current_page: 1,
      version: 0,
      currency: "",
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  componentDidMount() {
    // Log props to see what's available
    console.log("Component mounted with props:", this.props)
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.fromDate !== this.state.fromDate ||
      prevState.toDate !== this.state.toDate ||
      prevState.filter !== this.state.filter ||
      prevState.payment_method !== this.state.payment_method // Add this line
    ) {
      if (this.state.fromDate || this.state.toDate) {
        this.setState({ version: this.state.version + 1 })
        this.getData(1)
      }
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  getData = async (page) => {
    const { fromDate, toDate, filter, payment_method } = this.state

    var { status, message, data } = await API(
      this.props,
      "get",
      URL_PATH.orderHistory(page, fromDate, toDate, filter, payment_method), // Use payment_method from state
      {},
      {},
      page == 1 ? true : false,
    )

    if (status == "success") {
      console.log("Dataaaa", data)
      const { current_page, data: orders, last_page, per_page, total } = data

      this.setState({
        data: current_page == 1 ? orders : [...this.state.data, ...orders],
        current_page,
        lastPage: last_page,
        perPage: per_page,
        total,
      })

      return
    }
    if (status == "error") {
      this.showToast(message, "error")
      return
    }
    this.showToast("Something went wrong", "error")
  }
  paymentReceivedForOrder = async (item) => {
    const { id: orderId, mode = "cash" } = item;

    // Optimistically update the UI
    this.setState((prevState) => ({
      data: prevState.data.map((order) =>
        order.id === orderId
          ? {
            ...order,
            isProcessing: true,
            payment_method: mode // Optimistically update payment method
          }
          : order
      ),
    }));

    try {
      const { status, message, data } = await API(
        this,
        "post",
        URL_PATH.updatepaymentStatus,
        {
          order_id: orderId,
          payment_method: mode,
        }
      );

      if (status == "error") {
        // Revert if API call fails
        this.setState((prevState) => ({
          data: prevState.data.map((order) =>
            order.id === orderId
              ? {
                ...order,
                isProcessing: false,
                payment_method: 'unpaid' // Revert to unpaid
              }
              : order
          ),
        }));
        return this.props.okDialog(message);
      }

    // Show success message
    this.showToast("Payment accepted successfully!", "success");
            this.setState({ version: this.state.version + 1 })

  } catch (error) {
    // Handle network errors
    this.setState((prevState) => ({
      data: prevState.data.map((order) => 
        order.id === orderId 
          ? { 
              ...order, 
              isProcessing: false,
              payment_method: 'unpaid' // Revert to unpaid
            }
            : order
        ),
      }));
      this.showToast("Payment failed. Please try again.", "error");
    }
  }
  OrderCard = ({ item, index }) => {
    const {
      id: order_no,
      order_date_time,
      order_due_date_time,
      order_status,
      order_grand_total,
      order_type,
      created_at,
    } = item

    const orderDate = order_type === "dinein" ? created_at : (order_due_date_time ?? order_date_time)

    const status = item.order_status === "completed" ? "Waiting" : item.order_status === "kot" ? "Preparing" : "Served"

    const statusColor = order_status === "pending" ? "#FFC107" : order_status === "cooking" ? "#FF9800" : "#4CAF50"

    return (
      <Paper
        key={index}
        style={{
          backgroundColor: "#F5F5F5",
          borderRadius: 4,
          padding: 15,
          marginBottom: 10,
          border: this.state.selectedRows.includes(order_no) ? "1px solid #3f51b5" : "1px solid transparent",
        }}
        onLongPress={() => this.handleLongPress(order_no)}
        onClick={() => this.handleCardClick(order_no)}
      >
        <Typography variant="h6">Order ID: {order_no}</Typography>
        <Typography>Date: {orderDate}</Typography>
        <Typography variant="h5">{`${order_grand_total}`}</Typography>
      </Paper>
    )
  }

  handleLongPress = (order_no) => {
    // Handle long press logic here
    // Update the 'selected' state accordingly
  }

  handleCardClick = (order_no) => {
    // Handle card click logic here
    // Update the 'selected' state accordingly
  }

  handleFilterChange = (e) => {
    this.setState({
      filter: e.target.value,
      version: this.state.version + 1,
    })
  }

  exportToCSV = () => {
    const hotelId = this.props.selectedHotelId?.id;
    if (!hotelId) {
      this.showToast("No hotel selected", "error");
      return;
    }

    const { fromDate, toDate, filter, payment_method } = this.state;
    const params = new URLSearchParams();

    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    if (filter && filter !== 'all') params.append('filter', filter);
    if (payment_method && payment_method !== 'all_pay') params.append('payment_method', payment_method);

    const url = `${URL_PATH.exportOrderHistoryCSV(hotelId)}?${params.toString()}`;
    window.open(url, '_blank');
  };

  exportToPDF = () => {
    const hotelId = this.props.selectedHotelId?.id;
    if (!hotelId) {
      this.showToast("No hotel selected", "error");
      return;
    }

    const { fromDate, toDate, filter, payment_method } = this.state;
    const params = new URLSearchParams();

    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    if (filter && filter !== 'all') params.append('filter', filter);
    if (payment_method && payment_method !== 'all_pay') params.append('payment_method', payment_method);

    const url = `${URL_PATH.exportOrderHistoryPDF(hotelId)}?${params.toString()}`;
    window.open(url, '_blank');
  };

  handleFromDateChange = (e) => {
    this.setState({
      fromDate: e.target.value,
      version: this.state.version + 1,
    })
  }

  handleToDateChange = (e) => {
    this.setState({
      toDate: e.target.value,
      version: this.state.version + 1,
    })
  }
  // Add this method to your component
  // Add this method to your component
  formatDataForExport = (data) => {
    if (!data || data.length === 0) return []

    // Create a deep copy of the data
    const formattedData = JSON.parse(JSON.stringify(data))

    // Calculate totals
    let totalGST = 0
    let totalTip = 0
    let totalAmount = 0

    formattedData.forEach((item) => {
      // Extract numeric values from the data
      const gstValue = Number.parseFloat(item.order_tax_total || 0)
      const tipValue = Number.parseFloat(item.waiter_tip || 0)
      const amountValue = Number.parseFloat(item.order_grand_total || 0)

      totalGST += gstValue
      totalTip += tipValue
      totalAmount += amountValue
    })

    // Create a total row
    const totalRow = {
      id: "TOTAL",
      order_date_time: "",
      order_type: "",
      order_tax_total: `₹${totalGST.toFixed(2)} (Total GST)`,
      waiter_tip: `₹${totalTip.toFixed(2)}`,
      order_grand_total: `₹${totalAmount.toFixed(2)}`,
      order_status: "",
    }

    // Add the total row to the data
    formattedData.push(totalRow)

    return formattedData
  }

  // Helper method to get clean order status text
  getOrderStatusText = (status) => {
    switch (status) {
      case "completed":
        return "Completed"
      case "kot":
        return "Preparing"
      default:
        return "Served"
    }
  }

  validateDates = () => {
    if (this.state.fromDate && this.state.toDate && new Date(this.state.toDate) < new Date(this.state.fromDate)) {
      this.showToast("End date cannot be before start date", "error")
      this.setState({ toDate: "" })
      return false
    }
    return true
  }
  onDataLoad = (data) => {
    let totalGST = 0
    let totalWaiterTip = 0

    data.forEach((item) => {
      totalGST += Number.parseFloat(item.order_tax_total || 0)
      totalWaiterTip += Number.parseFloat(item.waiter_tip || 0)
    })

    this.setState({ totalGST, totalWaiterTip })
  }

  onView = (item) => {
    this.props.history.push(routes.admin.orders.show(this.props.hotels[0].hotel_slug, item.order_type_slug, item.id));
  }

  onDelete = async (item) => {
    const { status, message, data } = await API(this.props, "post", URL_PATH.deleteOrder(item.id))
    if (status == "success") {
      this.showToast(message, "success")
      this.setState({ version: this.state.version + 1 })
    } else {
      this.showToast(message, "error")
    }
  }

  // Handle selected rows change from Table component
  handleSelectedRowsChange = (rows) => {
    this.setState({ selectedRows: rows })
  }

  // Open bulk delete confirmation modal
  openBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: true })
  }

  // Close bulk delete confirmation modal
  closeBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: false })
  }

  // Bulk delete action
  onBulkAction = async (rows) => {
    const ids = Object.values(rows)
    console.log("Hotel Id is here", this.props.selectedHotelId?.id)

    try {
      const { status, message, data } = await API(
        this,
        "post",
        URL_PATH.deleteBulkOrderHistory(this.props.selectedHotelId.id),
        { ids },
      )

      if (status === true) {
        this.showToast(message, "success")
        this.setState({
          version: this.state.version + 1,
          selectedRows: [],
        })
      } else {
        this.showToast(message || "Operation failed", "error")
      }
    } catch (error) {
      this.showToast("An error occurred while processing your request", "error")
      console.error("Error:", error)
    }
  }
  componentDidMount() {
    // Check if hotel slug matches
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
      this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
      return;
    }


  }

  // Handle bulk delete confirmation
  handleBulkDeleteConfirmation = async () => {
    await this.onBulkAction(this.state.selectedRows)
    this.closeBulkDeleteConfirmationModal()
  }

  handlePaymentMethodChange = (e) => {
    this.setState({
      payment_method: e.target.value,
      version: this.state.version + 1,
    })
  }

  render() {
    const {
      selectedRows,
      isBulkDeleteConfirmationModalOpen,
      fromDate,
      toDate,
      filter,
      payment_method,
      version,
      currency,
      toast,
    } = this.state

    return (
      <Box className="container-fluid">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
            marginBottom: "20px",
          }}
        >
          <Header title="Order History" />
          <div className="d-flex flex-row justify-content-center" style={{ justifyContent: "center" }}>
            {selectedRows.length > 0 && (
              <>
                <Button
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  style={{
                    backgroundColor: ColorScheme.accentColor,
                    color: ColorScheme.textColor,
                    marginRight: "15px",
                  }}
                  onClick={this.openBulkDeleteConfirmationModal}
                >
                  Delete Selected ({selectedRows.length})
                </Button>
              </>
            )}

            {/* <Button
              variant="contained"
              startIcon={<PictureAsPdfIcon />}
              style={{
                backgroundColor: "#FFC857",
                color: "black",
                marginRight: "15px",
                fontWeight: "bold",
              }}
              onClick={this.exportToPDF}
            >
              PDF
            </Button> */}

            {/* <Button
              variant="contained"
              startIcon={<TableChartIcon />}
              style={{
                backgroundColor: "#02111B",
                color: ColorScheme.textColor,
                border: "1px solid #FFC857",
                marginRight: "15px",
                fontWeight: "bold",
              }}
              onClick={this.exportToCSV}
            >
              CSV
            </Button> */}
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Filter"
                  select
                  fullWidth
                  value={filter}
                  onChange={this.handleFilterChange}
                  size="small"
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="dinein">Dine In</MenuItem>
                  <MenuItem value="takeaway">Pickup</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Payment Method"
                  select
                  fullWidth
                  value={payment_method}
                  onChange={this.handlePaymentMethodChange}
                  size="small"
                >
                  <MenuItem value="all_pay">All Payment Methods</MenuItem>
                  <MenuItem value="cash">Cash</MenuItem>
                  <MenuItem value="online">Online</MenuItem>
                  <MenuItem value="credit_card">Credit Card</MenuItem>
                  <MenuItem value="debit_card">Debit Card</MenuItem>
                  <MenuItem value="upi">UPI</MenuItem>
                  <MenuItem value="net_banking">Net Banking</MenuItem>
                  <MenuItem value="Bank_transfers">Bank Transfer</MenuItem>
                  <MenuItem value="unpaid">Un Paid</MenuItem>

                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <CustomDatePicker
                  label="Start Date"
                  fullWidth
                  placeholder="dd-mm-yyyy"
                  size="small"
                  value={fromDate}
                  onChange={this.handleFromDateChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <CustomDatePicker
                  label="End Date"
                  placeholder="dd-mm-yyyy"
                  fullWidth
                  size="small"
                  value={toDate}
                  onChange={this.handleToDateChange}
                  onBlur={this.validateDates}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

            </Grid>
          </div>
        </div>

        {/* <Table
          key={version}
          api={URL_PATH.orderHistory(this.state.page, fromDate, toDate, filter)}
          onView={this.onView}
          export={true} 

          searchPlaceholder="Search by order no"
          deleteTitle="Are you sure you want to delete this order?"
          deleteText="All the data related to this order will be deleted"
          onDelete={this.onDelete}
          onSelectedRowsChange={this.handleSelectedRowsChange}
          selectedHotelId={this.props.selectedHotelId}
          row={[
            {
              title: "Order No",
              key: "id",
              sortable: false,
              type: "text",
            },
            {
              title: "Order Date",
              key: "order_date_time",
              sortable: false,
              type: "date",
              format: "DD/MM/YYYY, HH:mm",
              parse: (item) => {
                const dateValue =
                  item.order_type === "dinein" ? item.created_at : (item.order_due_date_time ?? item.order_date_time)

                return moment(dateValue).format("DD/MM/YYYY, HH:mm")
              },
            },
            {
              title: " Order Type",
              key: "order_type",
              sortable: false,
              type: "typeBadge",
              parse: (item) => {
                if (item.order_type === "dinein") {
                  return {
                    text: "Dine In",
                    bgColor: " #691727",
                    textColor: " white",
                    icon: assets.dineinIcon,
                  }
                } else {
                  return {
                    text: "Take Away",
                    bgColor: " #453E2A",
                    textColor: " white",
                    icon: assets.pickupIcon,
                  }
                }
              },
            },

            {
              title: "Amount",
              key: "order_grand_total",
              sortable: false,
              type: "text",
              parse: (item) => {
                return `₹${currency} ${item.order_grand_total}`
              },
            },
            {
              title: "Order Status",
              key: "order_status",
              sortable: false,
              type: "statusBadge",
              parse: (item) => {
                if (item.order_status === "completed") {
                  return {
                    text: "Completed",
                    bgColor: "#9ED7B9", // Green
                    textColor: "green",
                    borderColor: "green",
                    icon: <CheckCircleOutlineIcon style={{ fontSize: "14px" }} />,
                  }
                } else if (item.order_status === "kot") {
                  return {
                    text: "Preparing",
                    bgColor: "#FF9800", // Orange
                    textColor: "#000000",
                    icon: <RestaurantIcon style={{ fontSize: "14px" }} />,
                  }
                } else {
                  return {
                    text: "Served",
                    bgColor: "#94C3E8", // Blue
                    textColor: "#0D6EFD",
                    icon: <LocalShippingIcon style={{ fontSize: "14px" }} />,
                  }
                }
              },
            },
          ]}
        /> */}
        <Table
          key={version}
          api={URL_PATH.orderHistory(this.state.page, fromDate, toDate, filter, payment_method)}
          onView={this.onView}
          export={true}
          onDataLoad={this.onDataLoad}
          exportDataFormatter={this.formatDataForExport} // Add this prop
          exportFileName="order_history_with_taxes"
          searchPlaceholder="Search by order no"
          deleteTitle="Are you sure you want to delete this order?"
          deleteText="All the data related to this order will be deleted"
          onDelete={this.onDelete}
          onSelectedRowsChange={this.handleSelectedRowsChange}
          selectedHotelId={this.props.selectedHotelId}
        row={[
  {
    title: "Order No",
    key: "id",
    sortable: false,
    type: "text",
  },
  {
    title: "Order Date",
    key: "order_date_time",
    sortable: false,
    type: "date",
    format: "DD/MM/YYYY, HH:mm",
    parse: (item) => {
      const dateValue =
        item.order_type === "dinein" ? item.created_at : (item.order_due_date_time ?? item.order_date_time)
      return moment(dateValue).format("DD/MM/YYYY, HH:mm")
    },
  },
  {
    title: "Order Type",
    key: "order_type",
    sortable: false,
    type: "typeBadge",
    parse: (item) => {
      if (item.order_type === "dinein") {
        return {
          text: "Dine In",
          bgColor: " #691727",
          textColor: " white",
          icon: assets.dineinIcon,
        }
      } else {
        return {
          text: "Pickup",
          bgColor: " #453E2A",
          textColor: " white",
          icon: assets.pickupIcon,
        }
      }
    },
  },
  {
    title: "GST Amount",
    key: "order_tax_total",
    sortable: false,
    type: "text",
    parse: (item) => {
      return `₹${item.order_tax_total || "0.00"} (${item.order_tax_percentage || "0"}%)`
    },
  },

{
  title: "Payment Method",
  key: "payment_method",
  sortable: false,
  type: "text",
  parse: (item) => {
    // For paid orders, display the payment method
    if (item.payment_method && item.payment_method !== 'unpaid') {
      const method = item.payment_method || '';
      if (method === 'bank_transfers') return 'Bank Transfer';
      if (method === 'upi') return 'UPI';
      if (method === 'credit_card') return 'Credit Card';
      if (method === 'debit_card') return 'Debit Card';
      if (method === 'net_banking') return 'Net Banking';
      return method.charAt(0).toUpperCase() + method.slice(1).toLowerCase();
    }
    
    // For unpaid orders, create a select dropdown with "Unpaid" as default option
    return (
      <TextField
        select
        value={item.payment_method || 'unpaid'}
        onChange={(e) => {
          if (e.target.value !== 'unpaid') {
            this.paymentReceivedForOrder({...item, mode: e.target.value});
          }
        }}
        disabled={item.isProcessing}
        size="small"
        variant="outlined"
        fullWidth
        SelectProps={{
          displayEmpty: true,
          renderValue: (selected) => {
            if (!selected || selected === 'unpaid') {
              return 'Unpaid';
            }
            return selected.charAt(0).toUpperCase() + selected.slice(1);
          }
        }}
      >
        <MenuItem disabled value="unpaid">
          Unpaid
        </MenuItem>
        <MenuItem value="cash">Cash</MenuItem>
        <MenuItem value="online">Online</MenuItem>
        <MenuItem value="credit_card">Credit Card</MenuItem>
        <MenuItem value="debit_card">Debit Card</MenuItem>
        <MenuItem value="upi">UPI</MenuItem>
        <MenuItem value="net_banking">Net Banking</MenuItem>
        <MenuItem value="bank_transfers">Bank Transfer</MenuItem>
      </TextField>
    );
  }
},
  {
    title: "Tip",
    key: "waiter_tip",
    sortable: false,
    type: "text",
    parse: (item) => {
      return `₹${item.waiter_tip || "0.00"}`
    },
  },
  {
    title: "Amount",
    key: "order_grand_total",
    sortable: false,
    type: "text",
    parse: (item) => {
      return `₹${item.final_total}`
    },
  },
  {
    title: "Order Status",
    key: "order_status",
    sortable: false,
    type: "statusBadge",
    parse: (item) => {
      if (item.order_status === "completed") {
        return {
          text: "Completed",
          bgColor: "#E6F7ED",
          textColor: "#137947",
          borderColor: "#9ED7B9",
          icon: (
            <CheckCircleOutlineIcon
              style={{
                fontSize: "14px",
                color: "#137947",
                marginRight: "4px",
              }}
            />
          ),
          padding: "4px 8px",
          borderRadius: "12px",
          fontWeight: "500",
          fontSize: "0.75rem",
          display: "flex",
          alignItems: "center",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        }
      } else if (item.order_status === "kot") {
        return {
          text: "Preparing",
          bgColor: "#FF9800",
          textColor: "#000000",
          icon: <RestaurantIcon style={{ fontSize: "14px" }} />,
        }
      } else {
        return {
          text: "Completed",
          bgColor: "#E6F7ED",
          textColor: "#137947",
          icon: <CheckCircleOutlineIcon style={{ fontSize: "14px" }} />,
        }
      }
    },
  }
]}
        />
        {/* Bulk Delete Confirmation Modal */}
        <ConfirmationModal
          isOpen={isBulkDeleteConfirmationModalOpen}
          onConfirm={this.handleBulkDeleteConfirmation}
          onCancel={this.closeBulkDeleteConfirmationModal}
          title="Confirm Bulk Deletion"
          message={`Are you sure you want to delete the selected ${selectedRows.length} orders? All data related to these orders will be deleted.`}
          confirmText="Yes, delete them!"
          cancelText="Cancel"
        />

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleCloseToast}
        />
      </Box>
    )
  }
}

// Export the component wrapped with the redux HOC
export default redux(Orders)
